import { render, staticRenderFns } from "./operateAuthAddDialog.vue?vue&type=template&id=bf85026c&scoped=true&lang=pug"
import script from "./operateAuthAddDialog.vue?vue&type=script&lang=js"
export * from "./operateAuthAddDialog.vue?vue&type=script&lang=js"
import style0 from "./operateAuthAddDialog.vue?vue&type=style&index=0&id=bf85026c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85026c",
  null
  
)

export default component.exports